import React, { createContext, useContext } from 'react'

interface DropdownContextType {
  closeDropdown: (toastText?: string) => void
}

const DropdownContext = createContext<DropdownContextType | undefined>(undefined)

export const useDropdown = () => {
  const context = useContext(DropdownContext)
  if (context === undefined) {
    throw new Error('useDropdown must be used within a DropdownProvider')
  }
  return context
}

export const DropdownProvider: React.FC<{
  children: React.ReactNode
  onClose: () => void
}> = ({ children, onClose }) => {
  return <DropdownContext.Provider value={{ closeDropdown: onClose }}>{children}</DropdownContext.Provider>
}
